<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="设备uuid：" prop="code">
                    <el-input v-model.trim="form.device_id" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="uid：" prop="uid">
                    <el-input v-model.trim="form.uid" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="属性/事件：" prop="identifier">
                    <el-select v-model="form.identifier" placeholder="请选择" filterable clearable multiple collapse-tags
                        style="width: 200px;">
                        <el-option v-for="item in identifierList" :key="item.key" :label="item.value"
                            :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间：" prop="createTime">
                    <el-date-picker v-model="createTime" type="datetimerange" start-placeholder="开始时间"
                        end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini" @sort-change="handleSortChange">
            <el-table-column label="设备uuid" minWidth="250" prop="device_id" sortable="custom">
                <template v-slot="scope">
                    <span>{{ scope.row.device_id }}</span>
                </template>
            </el-table-column>
            <el-table-column v-for="item in visibleColumns" :key="item.key" :label="item.value" :prop="item.key"
                minWidth="200" sortable="custom">
                <template v-slot="scope">
                    <span>{{ scope.row[item.key] }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog title="" v-model="jsonVisible" width="1400px" center>
            <json-editor-vue class="editor" v-model="jsonValue" />
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../util/util'
import api from '../../../axios/api'
import JsonEditorVue from 'json-editor-vue3'
import dayjs from 'dayjs'

export default {
    components: {
        JsonEditorVue,
    },
    setup() {
        const router = useRouter()
        const form = reactive({
            device_id: '',
            uid: '',
            identifier: [],
            start_time: '',
            end_time: '',
            order_by: '',
            order: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const identifierList = ref([])
        const jsonVisible = ref(false)
        const jsonValue = ref('')
        const createTime = ref('')

        // 计算属性：只显示选中的列
        const visibleColumns = computed(() => {
            return identifierList.value.filter(item => form.identifier.includes(item.key))
        })

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        // 处理排序变化
        const handleSortChange = ({ column, prop, order }) => {
            console.log('排序变化:', { column, prop, order })

            if (order === null) {
                // 取消排序
                form.order_by = ''
                form.order = ''
            } else {
                // 设置排序字段和顺序
                form.order_by = prop
                form.order = order === 'ascending' ? 'ASC' : 'DESC'
            }

            // 重置到第一页并重新搜索
            pagination.page = 1
            onSearch()
        }

        const getOnlineIdentifierList = async () => {
            const res = await api.OnlineIdentifierList()
            console.log('getOnlineIdentifierList', res)
            if (res.data.code === 200) {
                identifierList.value = res.data.data.list || []
            }
        }

        const onSearch = async () => {
            console.log('toRaw(form)', toRaw(form))
            const res = await api.OnlineLogStatistics({
                ...toRaw(form),
                identifier: form.identifier.join(','),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { list: result, page_info } = res.data.data
                list.value = result
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.data.msg)
            }
        }

        const add = () => {
            router.push('/salespartner/list/add/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            // 重置排序
            form.order_by = ''
            form.order = ''
            onSearch()
        }

        const lookJson = (json) => {
            jsonValue.value = json ? JSON.parse(json) : ''
            jsonVisible.value = true
        }

        watch(createTime, (newVal) => {
            if (newVal) {
                form.start_time = dayjs(newVal[0]).format('YYYY-MM-DD HH:mm:ss')
                form.end_time = dayjs(newVal[1]).format('YYYY-MM-DD HH:mm:ss')
            } else {
                form.start_time = ''
                form.end_time = ''
            }
        })

        onMounted(() => {
            getOnlineIdentifierList()
        })


        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            handleSortChange,
            add,
            resetForm,
            util,
            jsonVisible,
            jsonValue,
            lookJson,
            createTime,
            identifierList,
            visibleColumns
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
    ::v-deep(tbody) {
        tr {
            font-family: 'Manrope';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            opacity: 0.8;
        }
    }
    .editor {
        height: 400px;
    }
}
</style>
